import { domToCanvas as toCanvas } from 'modern-screenshot';

/**
 * To determine actual value for a given value based on original and current
 * @param {number} val
 * @param {number} original
 * @param {number} current
 * @returns
 */
function getRelativeVal(val, original, current) {
    const percentage = (val / original) * 100;
    const actual = (percentage * current) / 100;
    return actual;
}
/**
 *
 * @param {canvas} sourceCanvas
 * @param {number} originalWidth
 * @param {number} originalHeight
 * @returns
 */
function cropCanvas(sourceCanvas, originalWidth, originalHeight) {
    // In pixels
    let left = 280;
    let top = 70;
    let bottom = 70;
    let right = 10;

    const leftToCrop = getRelativeVal(left, originalWidth, sourceCanvas.width);
    const topToCrop = getRelativeVal(top, originalHeight, sourceCanvas.height);
    const rightToAdd = getRelativeVal(right, originalWidth, sourceCanvas.width);
    const bottomToCrop = getRelativeVal(
        bottom,
        originalHeight,
        sourceCanvas.height
    );

    const destWidth = sourceCanvas.width - leftToCrop + rightToAdd;
    const destHeight = sourceCanvas.height - topToCrop - bottomToCrop;

    let destCanvas = document.createElement("canvas");
    destCanvas.width = destWidth;
    destCanvas.height = destHeight;

    destCanvas.getContext("2d").drawImage(
        sourceCanvas,
        leftToCrop,
        topToCrop,
        destWidth,
        destHeight, // source rect with content to crop
        0,
        0,
        destWidth,
        destHeight
    ); // newCanvas, same size as source rect

    return destCanvas;
}

/**
 *
 * @param {*} container
 * @param {function} cb
 */
export function captureElemPlayView(container, cb) {
    // Set white background color
    container.style.setProperty("background-color", "#fff");
    // hide close buttons
    const closeButtons = container.querySelectorAll(".tde-close-button");
    for (let el of closeButtons) el.style.visibility = "hidden";
    toCanvas(container, {quality: 1, scale: 2})
        .then(function (canvas) {
            // Remove background color
            container.style.removeProperty("background-color");
            // show close buttons
            for (let el of closeButtons) el.style.visibility = "visible";
            // Crop and send back the image
            cb(
                cropCanvas(
                    canvas,
                    container.offsetWidth,
                    container.offsetHeight
                )
            );
        })
        .catch(function (err) {
            console.log(err);
            cb(null);
            // show close buttons
            for (let el of closeButtons) el.style.visibility = "visible";
        });
}
